import axios from "axios";
import { errorLog } from "../../../logger";
import { createMultipartFormData } from "../../Tasks/utils/createMultipartFormData";
import ValidationError from "../../ZodError";
import { TaskDetails, ValidationError as TaskValidationError, } from "../Types";
import { tasksUrl } from "./urls";
export const postTask = async (requestData, idempotencyKey, files = {}, config) => {
    try {
        const url = tasksUrl("v4");
        // Create FormData for multipart request
        const formData = createMultipartFormData(requestData, files);
        const { data } = await axios.post(url, formData, {
            headers: {
                Authorization: `Bearer ${config.jwt}`,
                "Content-Type": "multipart/form-data",
                "Idempotency-key": idempotencyKey,
                ...("advisorId" in config && { Advisor: config.advisorId }),
            },
        });
        const decoded = TaskDetails.safeParse(data);
        if (decoded.success) {
            return decoded.data;
        }
        else {
            const errorMessage = `[postTask] received unexpected data`;
            errorLog(errorMessage, decoded.error.message);
            throw new ValidationError(errorMessage, decoded.error.issues);
        }
    }
    catch (error) {
        // Handle validation errors from API (HTTP 400)
        if (axios.isAxiosError(error) && error.response?.status === 400) {
            const validationError = TaskValidationError.safeParse(error.response.data);
            if (validationError.success) {
                const errorMessage = `[postTask] validation failed`;
                errorLog(errorMessage, JSON.stringify(validationError.data));
                throw new Error(errorMessage); // You might want to create a specific validation error class
            }
        }
        const errorMessage = `[postTask] failed`;
        errorLog(errorMessage, error instanceof Error ? error.message : String(error));
        throw error;
    }
};
//# sourceMappingURL=postTask.js.map